import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { YearCarouselProps } from '../../../types/carouselImage';

const YearCarousel: React.FC<YearCarouselProps> = ({
  images,
  className = '',
  aspectRatio = '3/4',
}) => {
  return (
    <div className={`year-carousel ${className}`}>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={24}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        loop={true}
        breakpoints={{
          576: {
            slidesPerView: 1,
          },
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          },
        }}
      >
        {images.map((image) => (
          <SwiperSlide key={image.id}>
            <div className="card h-100 shadow-sm position-relative overflow-hidden">
              {/* Badge anno in alto */}
              <div className="position-absolute top-0 start-0 m-3 z-2">
                <span className="badge bg-body text-body fs-6 px-3 py-2">
                  {image.year}
                </span>
              </div>

              {/* Immagine */}
              <div
                className="card-img-container"
                style={{
                  aspectRatio: aspectRatio,
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-100 h-100"
                  style={{
                    objectFit: 'cover',
                    objectPosition: 'center',
                  }}
                />
              </div>

              {/* Descrizione (opzionale) */}
              {image.description && (
                <div className="card-body">
                  <p className="card-text text-center text-muted mb-0">
                    {image.description}
                  </p>
                </div>
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Controlli di navigazione Bootstrap-style */}
    </div>
  );
};

export default YearCarousel;
